 <div class="quickSearchAutoComplete">
  <div [ngClass]="focus ? 'bar-focused' : 'bar'" class="row justify-content-md-end" >
     <div class="col-1 pl-0">
      <mat-icon svgIcon="search" class="search-icon searchBar" id="searchBar"></mat-icon>
    </div>
    <div #selectedSearch class="col-10 pl-0 bar-search-anime">
      <mat-form-field class="replace w-100" [floatLabel]="floatLabelType">
        <input id='toFocus' maxlength="12" matInput type="text" class="active" [matAutocomplete]="issuingAsset" (focus)="switchFocus()" (blur)="switchFocus()" (keyup)="onAutoCompletAsset($event)"
          ondragstart="return false;" ondrop="return false;" [value]="symbolAutoComplete" (keydown.enter)="onInputEnter($event)" class="cursor-pointer"
          placeholder="Pesquisa ..."
          >
      </mat-form-field>

      <mat-autocomplete class="quick-search-autocomplete-panel" #issuingAsset id="issuingAsset">
        <mat-option *ngFor="let item of filteredAssets"
          [value]="item.symbol"
          (click)="onAutoCompletAsset(item.symbol)"
          (onSelectionChange)="onchangeSymbol($event)">{{ item.symbol | uppercase }}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
</div>
